<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 3.5c0-.13.02-.26.08-.38.15-.38.52-.62.92-.62h10c.4 0 .77.24.92.62.16.37.07.8-.22 1.09l-5 5a.996.996 0 0 1-1.41 0l-5-5C.1 4.02 0 3.76 0 3.5z"
        />
    </svg>
</template>
